/**
 * Debug Utility
 * 
 * Provides debugging functions that only output logs in development mode.
 * This prevents sensitive information from being exposed in production.
 */

// Check if we're in development mode
const isDev = process.env.NODE_ENV === 'development';

// Create the debug object with conditional logging
const debug = {
  /**
   * Log debug information, only in development mode
   * @param {string} namespace - Category/module name for the log
   * @param {string} message - Message to log
   * @param {any} data - Optional data to log
   */
  log: (namespace, message, data) => {
    if (!isDev) return;
    
    if (data !== undefined) {
      console.log(`DEBUG ${namespace}: ${message}`, data);
    } else {
      console.log(`DEBUG ${namespace}: ${message}`);
    }
  },
  
  /**
   * Log errors, only in development mode
   * @param {string} namespace - Category/module name for the error
   * @param {string} message - Error message
   * @param {any} error - Optional error object
   */
  error: (namespace, message, error) => {
    if (!isDev) return;
    
    if (error !== undefined) {
      console.error(`DEBUG ${namespace}: ${message}`, error);
    } else {
      console.error(`DEBUG ${namespace}: ${message}`);
    }
  },
  
  /**
   * Log warnings, only in development mode
   * @param {string} namespace - Category/module name for the warning
   * @param {string} message - Warning message
   * @param {any} data - Optional data to log
   */
  warn: (namespace, message, data) => {
    if (!isDev) return;
    
    if (data !== undefined) {
      console.warn(`DEBUG ${namespace}: ${message}`, data);
    } else {
      console.warn(`DEBUG ${namespace}: ${message}`);
    }
  },
  
  /**
   * Group related logs, only in development mode
   * @param {string} namespace - Category/module name for the group
   * @param {string} label - Group label
   */
  group: (namespace, label) => {
    if (!isDev) return;
    console.group(`DEBUG ${namespace}: ${label}`);
  },
  
  /**
   * End a log group, only in development mode
   */
  groupEnd: () => {
    if (!isDev) return;
    console.groupEnd();
  }
};

export default debug; 